import React from "react";
import { COMPANY_LIST } from "../../companies";

const SWITCHER_ITEMS = [{ code: "all", label: "Tutte" }, ...COMPANY_LIST];

export const CompanySwitcher = ({ value, onChange }) => (
  <div className="flex items-center gap-1 bg-white border border-gray-200 rounded-lg p-1" data-testid="company-switcher">
    {SWITCHER_ITEMS.map((c) => (
      <button
        key={c.code}
        onClick={() => onChange(c.code)}
        data-testid={`company-switch-${c.code}`}
        className={`px-3 py-1.5 text-[12.5px] font-bold rounded-md transition-colors ${value === c.code ? "bg-[#16345c] text-white" : "text-gray-600 hover:bg-gray-100"}`}
      >
        {c.label}
      </button>
    ))}
  </div>
);
